import { useUpdateEffect } from 'ahooks';
import { Select, SelectProps } from 'antd';
import { FC, memo, useState } from 'react';
import { ChevronDown, Search } from 'react-bootstrap-icons';

import { FormSelectNotFoundContent } from '@/common/components';
import { parseSelectData } from '@/common/utils';

import { useAutocompleteDomainRegistrarAccountsMutation } from '@/modules/DomainRegistrars/queries';

interface Props extends Omit<SelectProps, 'notFoundContent' | 'options' | 'placeholder'> {
  domainRegistrarId: string | undefined;
}

export const DomainRegistrarsAccountsAutocomplete: FC<Props> = memo((props) => {
  const { domainRegistrarId, loading, value, disabled } = props;

  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);

  const { data, isError, error, isLoading, mutate, reset } = useAutocompleteDomainRegistrarAccountsMutation()();

  useUpdateEffect(() => {
    if (domainRegistrarId) {
      mutate(domainRegistrarId);
    } else {
      props.onChange?.(undefined, []);
      reset();
    }

    return () => {
      props.onChange?.(undefined, []);
    };
  }, [domainRegistrarId]);

  return (
    <Select
      { ...props }
      notFoundContent={
        <FormSelectNotFoundContent
          description="Немає акаунтів реєстратора домена"
          isError={ isError }
          error={ error }
        />
      }
      placeholder="Виберіть акаунт реєстратора домена"
      loading={ loading || isLoading }
      disabled={ isLoading || !domainRegistrarId || disabled }
      value={ isLoading ? undefined : value }
      options={ parseSelectData(data, {
        value: 'id',
        label: 'login'
      }) }
      onDropdownVisibleChange={ setDropdownIsOpen }
      defaultActiveFirstOption={ false }
      filterOption={ false }
      suffixIcon={
        dropdownIsOpen ? <Search/> : <ChevronDown/>
      }
    />
  );
});
